<template>
  <div :class="{ mobile: isNarrowWidthDevice }">
    <h1>404: Page Not Found</h1>
    <h5>The page you are looking for cannot be found.</h5>
    <p>The link may have been removed or does not exist.</p>
    <p>
      If you need help, please
      <a
        href="https://www.apnic.net/about-apnic/organization/contact-APNIC/"
        target="_blank"
      >
        contact us
        <fa icon="external-link-alt"></fa>
      </a>.
    </p>
    <p>
      Go back to
      <a href="/" @click.prevent="navigateToHomePage()">NetOX</a>.
    </p>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'NotFound',

  computed: {
    ...mapState(['isNarrowWidthDevice']),
  },

  methods: {
    navigateToHomePage() {
      this.$router.push('/');
    },
  },
};
</script>

<style scoped lang="scss">
div {
  position: relative;
  top: 25%;
  padding: 0 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  h5 {
    margin-bottom: 3rem;
  }
}

.mobile {
  align-items: flex-start;

  h1 {
    font-size: 1.75rem;
  }

  h5 {
    font-size: 1.25rem;
  }
}
</style>
